import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["draggable", "data-column"];
const _hoisted_2 = { class: "column__name" };
const _hoisted_3 = {
    key: 0,
    class: "colum__sizes"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
    key: 1,
    class: "column__sort",
    href: ""
};
import { ref } from 'vue';
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataTableColumnSelectionItem',
    props: {
        column: {},
        sortable: { type: Boolean },
        resizable: { type: Boolean }
    },
    emits: [
        'toggle',
        'resize'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const sizes = ref(['s', 'm', 'l', 'xl']);
        function toggle() {
            emit('toggle', props.column);
        }
        function selectSize(size) {
            emit('resize', props.column, size);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                onClick: _withModifiers(toggle, ["prevent"]),
                class: "dropdown__item column",
                draggable: __props.sortable,
                "data-column": __props.column.name
            }, [
                _createVNode(Icon, {
                    name: __props.column.selected ? 'check-square' : 'square'
                }, null, 8, ["name"]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("span", _hoisted_2, _toDisplayString(__props.column.label || __props.column.name), 1),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (__props.resizable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizes.value, (size) => {
                            return (_openBlock(), _createElementBlock("a", {
                                onClick: _withModifiers(($event) => (selectSize(size)), ["prevent", "stop"]),
                                href: "",
                                key: size,
                                class: _normalizeClass(["column__size", { 'column__size--selected': size === __props.column.size }])
                            }, _toDisplayString(size), 11, _hoisted_4));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (__props.sortable)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_5, [
                        _createVNode(Icon, { name: "sort" })
                    ]))
                    : _createCommentVNode("", true)
            ], 8, _hoisted_1));
        };
    }
});
